import { useImportDataOptions } from "@/hooks/use-import-data.hook.ts";
import { useImportDataResult } from "@/queries/import-data.query.ts";
import { ListItem, Modal, ModalProps, Skeleton, Stack, Text, Title } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

interface ImportDataErrorsModalProps extends ModalProps {
  importId: number;
}
export function ImportDataErrorsModal({ importId, ...props }: ImportDataErrorsModalProps) {
  const { t } = useTranslation();
  const { data: result, isLoading } = useImportDataResult(importId);
  const { getErrorCodeDescription } = useImportDataOptions();

  return (
    <Modal {...props} title={t("import_data:import_errors")} withCloser>
      {isLoading ? (
        <Stack gap={"sm"}>
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-3/4" />
          <Skeleton className="h-4 w-1/2" />
        </Stack>
      ) : (
        <Stack>
          {result?.errors_user?.map((error, index) => (
            <Stack key={index} gap={"xs"} className="border-b pb-3 last:border-b-0">
              <Title
                size={"sm"}
                header={
                  t("import_data:row_number", { number: error.row_number }) +
                  ": " +
                  getErrorCodeDescription(error.error_code)
                }
                paddingBottom
                paddingTop={index > 0}
              />
              {error.field_name && (
                <ListItem
                  layout={"two-columns"}
                  emphasis={"middle"}
                  preTitle={t("common:column")}
                  title={error.field_name}
                  valueSlot={
                    error.row_data[error.field_name] ? (
                      <Stack>
                        <Text className={"text-secondary"}>{t("common:value")}</Text>
                        <Text>{error.row_data[error.field_name] ?? "-"}</Text>
                      </Stack>
                    ) : undefined
                  }
                />
              )}
            </Stack>
          ))}
        </Stack>
      )}
    </Modal>
  );
}
